<div class="section">
  <h3 class="title"><b>Einrichtungsdaten bearbeiten</b></h3>
  <div class="container">
    <div class="flex column gap-12px">
      <p>Einrichtungsname: {{ profile.name }}</p>
      <p>Kundenummer: {{ profile.id }}</p>
    </div>

    <app-text-field
      label="USt-ID (optional)"
      appearance="outline"
      [inputControl]="formGroup.controls.taxId"
      [inputProps]="{ placeholder: 'DE123456789' }" />
    <app-text-field
      label="E-Mail Adresse"
      appearance="outline"
      [inputProps]="{
        maxlength: '70'
      }"
      [inputControl]="formGroup.controls.email"
      [errorMessages]="{
        required: 'errors.required' | translate
      }" />
    <app-text-field
      label="Telefonnummer"
      appearance="outline"
      [inputControl]="formGroup.controls.phone"
      [inputProps]="{
        maxlength: '70'
      }"
      [errorMessages]="{
        pattern: 'errors.invalidPhoneNumber' | translate,
        required: 'errors.required' | translate
      }" />
  </div>
</div>
